import { render, staticRenderFns } from "./questionConnect.vue?vue&type=template&id=37c22dcc&scoped=true"
import script from "./questionConnect.vue?vue&type=script&lang=js"
export * from "./questionConnect.vue?vue&type=script&lang=js"
import style0 from "./questionConnect.vue?vue&type=style&index=0&id=37c22dcc&prod&lang=less&scoped=true"
import style1 from "./questionConnect.vue?vue&type=style&index=1&id=37c22dcc&prod&scoped=true&lang=css"
import style2 from "./questionConnect.vue?vue&type=style&index=2&id=37c22dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c22dcc",
  null
  
)

export default component.exports